import { CamelCaseKeys } from '@uplift/types';


export enum ContactName {
  phone = 'phone',
  work = 'work',
  mobile = 'cell',
  home = 'home',
  email = 'email',
};


export enum ContactType {
  email = 'email',
  phone = 'phone',
};


export type UserContactPhone = CamelCaseKeys<{
  id: string;
  user_id: string;
  value: string;

  type: ContactType.phone;
  name: ContactName;
  verified: boolean;
}>;


export type UserContactEmail = CamelCaseKeys<{
  id: string;
  user_id: string;
  value: string;

  type: ContactType.email;
  name: 'email';
  verified: boolean;
}>;


export type UserContact = UserContactPhone | UserContactEmail;
